import { Box, Button, Dialog, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { tokens } from '../../../global/theme/tokens';
import FormHelperText from '../FormHelperText';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ExoExplorer from '../../exo/ExoExplorer';
import ExoDialog from '../../exo/ExoDialog';
import LabeledBox from '../../special/LabeledBox';
import MediaPreview from '../../exo/explorer/MediaPreview';
import ClearIcon from '@mui/icons-material/Clear';

const TypeImage = ({
  updateValidationOnChange,
  dataCollection,
  field,
  errors,
  size,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const [open, setOpen] = useState(false);
  const [img, setImg] = useState('');

  function handleClickImage() {
    setOpen(!open);
  }

  const handleSelect = (image) => {
    updateValidationOnChange(field.key, image);
    setImg(image.temporaryUrl);
    handleClickImage();
  };

  const handleReset = () => {
    updateValidationOnChange(field.key, null);
  };

  return (
    <>
      <Box className="flex gap-2 w-full">
        <LabeledBox
          size={size}
          onClick={() => setOpen(true)}
          sx={dataCollection[field.key] && { padding: '10px 14px' }}
          className="w-full flex flex-wrap gap-2 items-center"
          label={field.label}
          outerSx={
            dataCollection[field.key] && {
              maxWidth:
                size === 'small'
                  ? 'calc(100% - 40px - 0.5rem)'
                  : 'calc(100% - 56px - 0.5rem)',
            }
          }
        >
          {dataCollection[field.key] && (
            <Box className="flex items-center gap-4 w-full overflow-hidden">
              <MediaPreview
                src={dataCollection[field.key]?.temporaryUrl}
                onlyIcons={false}
                size={size === 'small' ? '23px' : '36px'}
              />
              <Typography className="whitespace-nowrap overflow-hidden text-ellipsis">
                {dataCollection[field.key]?.title}
              </Typography>
            </Box>
          )}
        </LabeledBox>

        {dataCollection[field.key] && (
          <Button
            onClick={handleReset}
            sx={{
              minWidth: 'unset',
              bgcolor: colors.bgInput,
              aspectRatio: '1/1',
              width: size === 'small' ? '40px' : '56px',
              height: size === 'small' ? '40px' : '56px',
              borderRadius: '10px',
              border: `1px solid transparent`,
              ':hover': {
                bgcolor: colors.error + '30',
                border: `1px solid ${colors.error}80`,
                color: colors.error,
              },
            }}
          >
            <ClearIcon />
          </Button>
        )}
      </Box>
      <ExoDialog open={open} onClose={() => setOpen(false)}>
        <ExoExplorer onSelect={handleSelect} />
      </ExoDialog>
    </>
  );
};

export default TypeImage;
